import '@/utils/authUtils'; // Ensure debug functions are attached to window
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById("root")!).render(<App />);

// Dynamically import Sentry + performance monitoring after the page is idle, so their
// bytes stay off the critical path and don't compete with the LCP image on mobile.
const runAfterIdle = (cb: () => void) => {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(cb, { timeout: 3000 });
  } else {
    setTimeout(cb, 2000);
  }
};
const scheduleDeferredInit = () => {
  runAfterIdle(() => {
    import('@/lib/sentry').then(m => m.initSentryDeferred());
    import('@/lib/performance').then(m => m.initPerformanceMonitoring());
  });
};
if (document.readyState === 'complete') {
  scheduleDeferredInit();
} else {
  window.addEventListener('load', scheduleDeferredInit, { once: true });
}

// Register Service Worker after page is interactive (non-blocking)
// In DEV/preview: unregister any existing SW and clear caches to ensure fresh content
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    if (import.meta.env.DEV || window.location.hostname.includes('preview')) {
      // Unregister all service workers in dev/preview
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
        console.log('SW unregistered for dev/preview');
      }
      // Clear all caches
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
        console.log('Cache cleared:', cacheName);
      }
    } else {
      // Production: register SW normally
      navigator.serviceWorker.register('/sw.js', { scope: '/' })
        .then(registration => {
          // Check for updates
          registration.update().catch(() => { });
        })
        .catch(err => {
          console.warn('SW registration failed:', err);
        });
    }
  });
}
